module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container hero"
  }, [_c('div', {
    staticClass: "column align-items-center"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Thank You")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "cta d-block mx-auto",
    attrs: {
      "to": "/personalCenter",
      "tag": "button"
    }
  }, [_vm._v("Go to customer center")]), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("\n        For immediate assistance or help with an application, please contact\n        us at:\n      ")]), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container posts-grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Recent Blog Posts")]), _vm._v(" "), _c('div', {
    staticClass: "row cards-row"
  }, _vm._l((_vm.postsGrid), function(post, index) {
    return _c('div', {
      key: index,
      staticClass: "col-12 col-md-6 col-lg-4 mb-4"
    }, [_c('div', {
      staticClass: "card px-0",
      on: {
        "click": function($event) {
          return _vm.redirectTo(post.routeName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.getImagePath(post.image)),
        expression: "getImagePath(post.image)"
      }],
      staticClass: "card-img-top",
      attrs: {
        "alt": post.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('span', {
      staticClass: "eyebrows"
    }, [_vm._v(_vm._s(post.eyebrows))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.text))]), _vm._v(" "), _c('div', {
      staticClass: "row mx-0 w-75 justify-content-between post-details"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v(_vm._s(post.author))]), _vm._v(" "), _c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v(_vm._s(post.date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })))])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Thanks for choosing American Credit, Inc.")]), _c('br'), _vm._v("\n        Our Business Financing Specialist will contact you shortly."), _c('br'), _vm._v("To expedite your approval process, please upload all the supporting documents such as equipment invoices and bank statements in the “File Upload” section at Customer Center.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-center mx-auto d-block"
  }, [_vm._v("Sales: "), _c('a', {
    attrs: {
      "href": "tel:8559040188"
    }
  }, [_vm._v("855-904-0188")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72be0a77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/thankYou.vue
// module id = 1993
// module chunks = 5